import React, { useMemo } from 'react';
import { Flex } from '@chakra-ui/react';
import MobileNavbarItem from './components/MobileNavbarItem';
import LegacyHomeIcon from '@/assets/LegacyHomeIcon';
import LegacyTrendIcon from '@/assets/LegacyTrendIcon';
import LegacyCategoryIcon from '@/assets/LegacyCategoryIcon';
import LegacyHeartIcon from '@/assets/LegacyHeartIcon';
import LegacyUserIcon from '@/assets/LegacyUserIcon';
import { useSafeRouter } from '@/hooks/route/useSafeRouter';
import { overlay } from 'overlay-kit';
import ProductCategoryModal, {
  CATEGORIES_MODAL_ID,
} from '@/components/products/ProductCategoryModal/ProductCategoryModal';
import FramerModal from '@/components/ui/FramerModal';

const MobileNavbar = () => {
  const router = useSafeRouter();

  const MOBILE_NAVBAR_ITEMS = useMemo(
    () => [
      {
        icon: <LegacyHomeIcon />,
        label: 'Home',
        onClick: () => {
          overlay.close(CATEGORIES_MODAL_ID);
          router.push('/');
        },
      },
      {
        icon: <LegacyCategoryIcon />,
        label: 'Categories',
        onClick: () => {
          try {
            overlay.open(
              ({ isOpen, close, unmount }) => (
                <FramerModal isOpen={isOpen} onExit={unmount} zIndex="sticky">
                  <ProductCategoryModal onClose={close} />
                </FramerModal>
              ),
              {
                overlayId: CATEGORIES_MODAL_ID,
              },
            );
          } catch (_) {
            overlay.close(CATEGORIES_MODAL_ID);
          }
        },
      },
      {
        icon: <LegacyTrendIcon />,
        label: 'Trend',
        onClick: () => {
          overlay.close(CATEGORIES_MODAL_ID);
          router.push('/trend');
        },
      },
      {
        icon: <LegacyHeartIcon />,
        label: 'Wishlist',
        onClick: () => {
          overlay.close(CATEGORIES_MODAL_ID);
          router.push('/wishlist');
        },
      },
      {
        icon: <LegacyUserIcon />,
        label: 'User',
        onClick: () => {
          overlay.close(CATEGORIES_MODAL_ID);
          router.push('/my-account');
        },
      },
    ],
    [router],
  );

  return (
    <Flex
      as="nav"
      display={{
        base: 'flex',
        mobile: 'flex',
        tablet: 'none',
        desktop: 'none',
      }}
      boxShadow="2px 0 12px 0 rgb(0 0 0 / .15)"
      position="fixed"
      bottom="0"
      width="100vw"
      height="fit-content"
      backgroundColor="white"
      zIndex="banner"
    >
      {MOBILE_NAVBAR_ITEMS.map((item) => (
        <MobileNavbarItem key={item.label} icon={item.icon} label={item.label} onClick={item.onClick} />
      ))}
    </Flex>
  );
};

export default MobileNavbar;
